Vue.component('ack-product-testimonial', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-product-testimonial',
    created() {

      this.testimonials = this.testimonialItems
    },
    mounted() {
      this.activeIndex = Math.floor(this.testimonials.length / 2);
    },
    props:{
      testimonialItems: { // :product-info
        type: Array,
        required: true
      },
      isMobile: {
        type: Boolean
      }
    },
    computed: {
      activeIndex() {
        return this.testimonials.length === 5 ? 2 : this.testimonials.length === 3 ? 1 : 0;
      },
      
      orderedAvatars() {
        // Clone the array and ensure there's an odd number of avatars
        let avatars = [...this.testimonials]
        let half_length = Math.floor(avatars.length / 2)

        // Rotate the array so that the active avatar is in the middle
        while (this.activeIndex !== half_length) {
          if (this.activeIndex > half_length) {
            avatars.unshift(avatars.pop())
            this.activeIndex--
          } else {
            avatars.push(avatars.shift())
            this.activeIndex++
          }
        }

        // Mark the middle avatar as active
        avatars = avatars.map((avatar, index) => ({
          ...avatar,
          active: index === half_length
        }))

        return avatars
      },
      
    },
    data() {
      return {
        testimonials: []
      }
    },
    methods: {
        
        setActiveAvatar(index) {
          // Rotate the testimonials array to make the clicked avatar centered
          const length = this.testimonials.length
          const mid = Math.floor(length / 2)
          let toMove = (index + length - mid) % length

          for (let i = 0; i < toMove; i++) {
            this.testimonials.push(this.testimonials.shift())
          }

          // Update the active index
          this.activeIndex = mid
        }
    },
    
    beforeDestroy() {

    },
    watch: {
      prop1: {
        handler() {


        },
        deep: false
      }
    }
  })